export default __webpack_public_path__ + "static/media/mobile.65bad9f8.jpg";